module.exports = __webpack_public_path__ + "assets/img/xiaolv.2ae224f3.png";